//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "table",
  data: function data() {
    return {
      headerHeight: '',
      height: '',
      scrollCheck: ""
    };
  },
  watch: {
    scrollSpeed: function scrollSpeed() {
      this.setTime();
    },
    scroll: {
      handler: function handler() {
        this.setTime();
      }
    }
  },
  computed: {
    showHeader: function showHeader() {
      return this.option.showHeader;
    },
    scrollTime: function scrollTime() {
      return this.option.scrollTime;
    },
    scrollSpeed: function scrollSpeed() {
      return this.option.scrollSpeed || 1;
    },
    scroll: function scroll() {
      return this.option.scroll;
    },
    cellHeight: function cellHeight() {
      return parseInt((this.height - this.headerHeight) / this.option.count);
    }
  },
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.height = parseInt(_this.$el.clientHeight);
      _this.headerHeight = parseInt(_this.$refs.table.$refs.headerWrapper.clientHeight);
      setTimeout(function () {
        _this.setTime();
      }, _this.scrollTime);
    });
  },
  methods: {
    cellClick: function cellClick(row, column, cell, event) {
      this.updateClick(row);
      this.clickFormatter && this.clickFormatter({
        type: column,
        item: row,
        data: this.dataChart
      }, this.getItemRefs());
    },
    setTime: function setTime() {
      var _this2 = this;

      clearInterval(this.scrollCheck);
      this.height = parseInt(this.$el.clientHeight);
      this.headerHeight = parseInt(this.$refs.table.$refs.headerWrapper.clientHeight);
      var table = this.$refs.table;
      var divData = table.bodyWrapper;
      var speed = this.scrollSpeed;
      var top = 0;

      if (this.scroll) {
        this.scrollCheck = setInterval(function () {
          top = top + speed;
          divData.scrollTop += speed;

          if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
            divData.scrollTop = 0;
          }

          if (top >= _this2.cellHeight && _this2.scrollTime) {
            divData.scrollTop = divData.scrollTop - (top - _this2.cellHeight);
            clearInterval(_this2.scrollCheck);
            setTimeout(function () {
              _this2.setTime();
            }, _this2.scrollTime);
          }
        }, 20);
      } else {
        divData.scrollTop = 0;
      }
    },
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;
      return {
        padding: 0,
        height: this.setPx(this.cellHeight),
        fontSize: this.setPx(this.option.bodyFontSize),
        color: this.option.bodyColor,
        textAlign: column.type == 'index' ? 'center' : this.option.bodyTextAlign,
        backgroundColor: rowIndex % 2 == 0 ? this.option.othColor : this.option.nthColor
      };
    },
    rowStyle: function rowStyle(_ref2) {
      var rowIndex = _ref2.rowIndex;
      return {
        backgroundColor: 'transparent'
      };
    },
    headerRowStyle: function headerRowStyle() {
      return {
        backgroundColor: this.option.headerBackground
      };
    },
    headerCellStyle: function headerCellStyle(_ref3) {
      var row = _ref3.row,
          column = _ref3.column,
          rowIndex = _ref3.rowIndex,
          columnIndex = _ref3.columnIndex;
      return {
        fontSize: this.setPx(this.option.headerFontSize),
        backgroundColor: this.option.headerBackground,
        color: this.option.headerColor,
        textAlign: column.type == 'index' ? 'center' : this.option.headerTextAlign
      };
    }
  }
});